import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHandshake, faGem, faDollarSign, faLightbulb, faChartLine, faHome } from '@fortawesome/free-solid-svg-icons';
import Section from '../ui/Section';
import Heading from '../ui/Heading';

const CoreValues = () => {
  const values = [
    {
      icon: faHandshake,
      title: "Commitment to Promises",
      description: "We deliver what we promise, ensuring that our customers' trust is never misplaced."
    },
    {
      icon: faGem,
      title: "Quality Construction",
      description: "We never compromise on the quality of materials and workmanship in our projects."
    },
    {
      icon: faDollarSign,
      title: "Affordability",
      description: "We believe that luxury shouldn't be exclusive, which is why we strive to make our projects accessible."
    },
    {
      icon: faLightbulb,
      title: "Innovation",
      description: "Each project incorporates innovative ideas tailored to enhance sustainability and functionality."
    },
    {
      icon: faChartLine,
      title: "Value Appreciation",
      description: "We choose locations with future development potential to ensure value appreciation for our customers."
    },
    {
      icon: faHome,
      title: "Customer-Centric",
      description: "Our home buyers' dreams and budgets guide our development process at every stage."
    }
  ];

  return (
    <Section className='py-6 sm:py-10 sm:px-5 lg:px-10'>
      <div className="text-center mb-12">
        <Heading level={2}>Our Core Values</Heading>
        <p className="text-gray-600 max-w-3xl mx-auto">
          These principles guide every decision we make and every project we undertake at Vasudharini.
        </p>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">
        {values.map((value, index) => (
          <div key={index} className="bg-white p-6 rounded-lg border-t-4 border-yellow-500">
            <div className="text-4xl mb-4 text-yellow-500">
              <FontAwesomeIcon icon={value.icon} />
            </div>
            <h3 className="text-lg font-medium mb-2">{value.title}</h3>
            <p className="text-gray-700">{value.description}</p>
          </div>
        ))}
      </div>
    </Section>
  );
};

export default CoreValues;
